import { ReactElement, useEffect, useRef, useState } from 'react'
import {
    Accordion,
    Button,
    Grid,
    SVG,
    SVGs,
    Text,
} from '@raskrask-dk/rr-components'
import { PropsCompanyCardTemplate } from './props'
import { useTranslation } from 'react-i18next'
import { StyledCompanyCard } from './styles'

const CompanyCardTemplate = ({
    children,
    choosenText,
    hasValueChoosen,
    onClickNext,
    open,
    setOpen,
    showNextButton = true,
    title,
    dataCy,
}: PropsCompanyCardTemplate): ReactElement => {
    const { t } = useTranslation()

    const companyCardRef = useRef<HTMLDivElement>(null)

    const [delayedOpen, setDelayedOpen] = useState(false)

    useEffect(() => {
        if (open) {
            companyCardRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
            })
            setTimeout(() => setDelayedOpen(open), 200)
        } else {
            setDelayedOpen(open)
        }
    }, [open])

    return (
        <StyledCompanyCard isOpen={delayedOpen} ref={companyCardRef}>
            <Accordion
                data-cy={dataCy}
                content={
                    <Grid gap="16">
                        {children}
                        {showNextButton && (
                            <Button
                                css={{ bgc: '$neutral100' }}
                                onClick={onClickNext}
                                size="large"
                                variant="plain"
                                data-cy="accordion-cta"
                                endIcon={<SVG src={SVGs.ChevronRight} />}
                            >
                                {t('common:continue')}
                            </Button>
                        )}
                    </Grid>
                }
                isOpen={open}
                title={
                    <Grid>
                        <Text
                            size={hasValueChoosen && !open ? 's' : 'm'}
                            bold={open}
                            css={{ transition: '$default' }}
                        >
                            {title}
                        </Text>
                        {choosenText && hasValueChoosen && !open && (
                            <Text
                                bold
                                size="l"
                                css={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                }}
                            >
                                {choosenText.join(', ')}
                            </Text>
                        )}
                    </Grid>
                }
                onClick={setOpen}
            />
        </StyledCompanyCard>
    )
}

export default CompanyCardTemplate
